/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-01 18:26:49
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-01-03 14:56:29
 * @FilePath: \sns-user-frontend\src\stores\search.js
 * @Description: 搜索页仓库
 */
import { defineStore } from "pinia"

export const useSearchStore = defineStore('searchStore', {
  state: () => ({
    historySearchTags: [],
    visible: false,
    wapVisible: false
  }),
  getters: {
   
  },
  actions: {
    setHistorySearchTags (e) {
      let history = this.historySearchTags
      if (history.includes(e)) {
        history.splice(history.indexOf(e), 1)
        history.unshift(e)
      } else {
        history.unshift(e)
      }
      if (history.length > 10) {
        history.pop()
      }
      this.historySearchTags = [ ...history ]
      localStorage.setItem('searchList', JSON.stringify([ ...history ]))
    },
    clearHistoryTags () {
      this.historySearchTags = []
      localStorage.removeItem('searchList')
    },
    openSearch () {
      this.showSearch = !this.showSearch
    },
  }

})